import React from 'react'
import T from 'prop-types'
import Calendar from './Calendar'
import TextInput from './TextInput'
import MenuOwner from './MenuOwner'
import moment from 'moment'
import cx from 'classnames'

export default class DateInput extends React.Component {
  static displayName = 'DateInput'
  static propTypes = {
    calendarAlign: T.oneOf(['top', 'left', 'bottom']),
    calendarClass: T.string,
    dateFormat: T.string,
    initialValue: T.instanceOf(Date),
    onBlur: T.func,
    onFocus: T.func,
    onSave: T.func,
    onSaveArgs: T.array,
    utc: T.bool,
    validRange: T.array, // [startTime|null, endTime|null] range of valid selections
    //...plus all others from TextInput

    menuAnchor: T.string
  }

  static defaultProps = {
    dateFormat: 'MM/DD/YYYY',
    calendarAlign: 'top',
    utc: false,
    menuAnchor: 'top-left',
    validRange: [null, null]
  }

  constructor(props) {
    super(props)
    this.state = {
      isMenuOpen: false
    }
  }

  closeMenu = () => {
    this.setState({ isMenuOpen: false })
  }

  openMenu = () => {
    this.setState({ isMenuOpen: true })
  }

  _moment = value => {
    return this.props.utc ? moment.utc(value) : moment(value)
  }

  _onDateSelect = date => {
    const {
      onSave,
      onSaveArgs=[]
    } = this.props
    if (onSave) {
      onSave(date, ...onSaveArgs)
    }
    this.closeMenu()
  }

  _onCalendarDateClick = date => {
    // Calendar date clicks pass through as a TextInput value
    this._textInputRef.setValue(this._getFormattedDate(+date), () => {
      this._textInputRef.save()
    })
  }

  _onTextInputSave = value => {
    const date = this._moment(value, this.props.dateFormat)
    this._onDateSelect(date.toDate())
  }

  _validateManualDateEntry = value => {
    if (!value) {
      return null
    }
    const { validRange, dateFormat } = this.props
    const date = this._moment(value, this.props.dateFormat)
    if (!date.isValid()) {
      return `Invalid date. Correct format is ${dateFormat}`
    }
    if (validRange || validRange.length === 2) {
      const timestamp = +date
      if (validRange[0] != null && timestamp < validRange[0]) {
        return `Date must be later than ${this._moment(validRange[0]).format(
          dateFormat
        )}`
      }
      if (validRange[1] != null && timestamp > validRange[1]) {
        return `Date must be earlier than ${this._moment(validRange[1]).format(
          dateFormat
        )}`
      }
    }
    return null // Valid entry
  }

  _onTextInputFocus = () => {
    const onFocus = this.props.onFocus
    if (onFocus) onFocus()
    this.openMenu()
  }

  _onTextInputBlur = () => {
    if (!this._ignoreNextBlur) {
      this.closeMenu()
    }
    delete this._ignoreNextBlur
    const onBlur = this.props.onBlur
    if (onBlur) {
      onBlur.call(this)
    }
  }

  _onMenuMouseDown = () => {
    this._ignoreNextBlur = true
  }

  _getFormattedDate = timestamp => {
    return this._moment(timestamp).format(this.props.dateFormat)
  }

  _onTextInputRef = textInput => {
    this._textInputRef = textInput
  }

  _renderMenu = () => {
    return (
      <div
        className={cx(
          'dateinput_calendar_popup',
          this.props.calendarAlign,
          this.props.calendarClass
        )}
        onMouseDown={this._onMenuMouseDown}
      >
        <Calendar
          onDateSelect={this._onCalendarDateClick}
          selectedDate={this.props.initialValue || new Date()}
          utc={this.props.utc}
          validRange={this.props.validRange}
        />
      </div>
    )
  }

  render() {
    const { initialValue, menuAnchor } = this.props
    const { isMenuOpen } = this.state

    return (
      <MenuOwner
        onClose={this.closeMenu}
        renderMenu={this._renderMenu}
        isMenuOpen={isMenuOpen}
        menuAnchor={menuAnchor}
      >
        <TextInput
          {...this.props}
          initialValue={
            initialValue ? this._getFormattedDate(initialValue) : null
          }
          onBlur={this._onTextInputBlur}
          onFocus={this._onTextInputFocus}
          onSave={this._onTextInputSave}
          validator={this._validateManualDateEntry}
          ref={this._onTextInputRef}
        />
      </MenuOwner>
    )
  }
}
